import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { Observable } from "rxjs";

import {
  DateChangeDialogComponent,
  DateChangeDialogData,
  DateChangeDialogResult,
  DateChangeReason,
} from "@shared/components";
import { BaseModalService } from "./base-modal.service";

export interface DeadlineDialogConfig {
  originalDate?: string | Date;
  reasons: DateChangeReason[];
}

export interface ReprojectionDialogConfig {
  originalDate?: string | Date;
  reasons: DateChangeReason[];
}

@Injectable({
  providedIn: "root",
})
export class DateChangeDialogService extends BaseModalService<
  DateChangeDialogComponent,
  DateChangeDialogResult
> {
  constructor() {
    super(inject(MatDialog));
  }

  protected getDefaultConfig(): MatDialogConfig {
    return {
      width: "680px",
      maxWidth: "90vw",
      disableClose: false,
      autoFocus: true,
      restoreFocus: true,
    };
  }

  open(
    data: DateChangeDialogData,
    config?: MatDialogConfig,
  ): Observable<DateChangeDialogResult | null | undefined> {
    return this.openModal(DateChangeDialogComponent, data, config);
  }

  openDeadlineDialog(
    config: DeadlineDialogConfig,
  ): Observable<DateChangeDialogResult | null | undefined> {
    return this.open({
      title: "Add Client Deadline",
      originalDate: config.originalDate,
      originalDateLabel: "Original Date",
      reasons: config.reasons,
      reasonLabel: "Reason",
      newDateLabel: "Requested Deadline",
      commentsLabel: "Comments (optional)",
      commentsPlaceholder: "Leave a commnet",
      saveButtonText: "Save",
      cancelButtonText: "Cancel",
      dateErrorMessage: "Deadline must be a future date",
    });
  }

  openReprojectionDialog(
    config: ReprojectionDialogConfig,
  ): Observable<DateChangeDialogResult | null | undefined> {
    return this.open({
      title: "Reproject Order",
      originalDate: config.originalDate,
      originalDateLabel: "Original Date",
      reasons: config.reasons,
      reasonLabel: "Reason",
      newDateLabel: "Reprojection Date",
      commentsLabel: "Comments (optional)",
      commentsPlaceholder: "Leave a comment",
      saveButtonText: "Reproject",
      cancelButtonText: "Cancel",
      dateErrorMessage: "Reprojection date must be in the future",
    });
  }
}
